import { useEffect, useState } from "react";
import { useRouletteHistory } from "../../../services/gameBoards";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import TranslatesContent from "../../../DataStore/Languages/translatesContent";

const Boards = ({ config, isLoad }) => {
  const [gameResult, setGameResult] = useState({});
  const [gameConfig, setGameConfig] = useState([]);
  const { data, isLoading } = useRouletteHistory();

  const loadGame = (gameLink) => {
    if (gameLink === 4) {
      window.location.replace("/liveroulettev2/#rou" + gameLink);
    } else {
      window.location.replace("/liveroulette/#rou" + gameLink);
    }
  };

  useEffect(() => {
    if (!isLoad && config) {
      const configData = Object.values(config);
      configData[1]["rou"][1].shift();
      setGameConfig(configData[1]["rou"][1] || []);
    }
  }, [isLoad, config]);

  useEffect(() => {
    if (!isLoading && data) {
      // data is the gameResult object: { "1": ["ROU-1", [...] ], ... }
      setGameResult(data);
    }
    console.log("gameResult", data);
  }, [isLoading, data]);

  const tables = Object.entries(gameResult);

  return (
    <div className="row">
      {tables.map(([tblKey, tblValue]) => {
        const tbl = Number(tblKey); // 1-based table number

        // gameConfig is 0-based and each row is like [img, name, min, max, openFlag]
        const cfg = gameConfig[tbl -1];
        const isClosed = cfg && cfg[4] === 0;

        const tableName = tblValue?.[0];
        const tableHistory = tblValue?.[1];
        const lastResults = tableHistory?.[0];
        const statistics = tableHistory?.[1]?.statictics;

        return (
          <div
            className="col-lg-4 mb-4"
            style={{ position: "relative", cursor: "pointer" }}
            key={tblKey}
            onClick={!isClosed ? () => loadGame(tbl) : null}
          >
            {isClosed ? (
              <div className="position-absolute top-50 start-50 translate-middle d-flex flex-column justify-content-center align-items-center tableClose tableCloseText">
                <div className="row">
                  <div className="tableCloseText">Closed</div>
                </div>
              </div>
            ) : (
              <div className="content-overlay text-center pt-5">
                <button className="hoverButton" onClick={() => loadGame(tbl)}>
                  <TranslatesContent contentKey="all-games-play-button" />
                </button>
              </div>
            )}
            <div className="row border rounded border-white p-1">
              <div className="row m-0 bg-white">
                <div className="col-12 text-center my-3">
                  <div className="d-flex justify-content-center">
                    {lastResults && lastResults.length ? (
                      lastResults.map((item, i) => (
                        <div
                          key={i}
                          id={`result-d-${i}`}
                          className={`flex-fill ${
                            i === 0 ? "newRouletteResultBoxRed active" : ""
                          }`}
                          style={{
                            border: i === 0 ? "1px solid #fff" : "",
                            color: i === 0 ? "#fff" : item[1],
                            backgroundColor: i === 0 ? item[1] : "",
                          }}
                        >
                          {item[0]}
                        </div>
                      ))
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
                <div className="col-12 text-center mb-3">
                  <div className="d-flex justify-content-center">
                    <div className="flex-fill">
                      <div className="newRouletteResText text-black">RED</div>
                      <div id="newRouletteResred" className="newRouletteResRed">
                        {statistics ? statistics.red + "%" : "N/A"}
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div className="newRouletteResText text-black">BLACK</div>
                      <div id="newRouletteResblack" className="newRouletteResBlack">
                        {statistics ? statistics.black + "%" : "N/A"}
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div className="newRouletteResText text-black">1-18</div>
                      <div id="newRouletteRes1-18" className="newRouletteRes118">
                        {statistics ? statistics["1-18"] + "%" : "N/A"}
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div className="newRouletteResText text-black">19-36</div>
                      <div id="newRouletteRes19-36" className="newRouletteRes1936">
                        {statistics ? statistics["19-36"] + "%" : "N/A"}
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div className="newRouletteResText text-black">ODD</div>
                      <div id="newRouletteResodd" className="newRouletteResOdd">
                        {statistics ? statistics.odd + "%" : "N/A"}
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div className="newRouletteResText text-black">EVEN</div>
                      <div id="newRouletteReseven" className="newRouletteResEven">
                        {statistics ? statistics.even + "%" : "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="row">
                  <div className="col-6 tableCountBoardName">
                    {tableName || `ROU-${tbl}`}
                  </div>
                  <div className="col-6">
                    <div className="tableCountBoardLimit text-end">
                      {cfg ? cfg[2] : "N/A"} - {cfg ? cfg[3] : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Boards;
